import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CampaignFinanceService } from "../../../@core/api/campaignFinance.service";
import { CampaignFinance} from "../../../@core/data/campaignFinance";
import codes from "../../../../assets/data/country_code.json";
import { HttpClient } from "@angular/common/http";
import { CampaignService } from "../../../@core/utils/campaign.service";

@Component({
  selector: "ngx-finance-campaign-new",
  templateUrl: "./finance-campaign-new.component.html",
  styleUrls: ["./finance-campaign-new.component.scss"],
})
export class FinanceCampaignNewComponent implements OnInit {
  campaign: CampaignFinance = {
    id: "",
    offer_id: "",
    dayOfTheWeek: [true, true, true, true, true, true, true],
    includedAreas: [],
    excludedJobs: [],
    privacies: [],
  };

  countryCodes: any[] = [];
  offerIds: any = [];
  loading: boolean = false;
  id: string;

  provinces: any[] = [];
  filteredProvinces: any[] = [];
  activeInputIndex: number | null = null;

  jobs: any[] = []; // Lista di tutte le professioni
  filteredJobs: any[] = []; // Professioni filtrate
  activeJobInputIndex: number | null = null; // Indice dell'input attivo


  timeOffset:number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campaignFinanceService: CampaignFinanceService,
    private http: HttpClient,
    private campaignService: CampaignService
  ) {}

  async ngOnInit() {
    let id = this.route.snapshot.params["id"];
    this.countryCodes = <any>codes;
    
    const date1 = new Date();
    this.timeOffset = date1.getTimezoneOffset()/60;

    if (id) {
      this.loading = true;
      this.id = id;
      this.campaign = <CampaignFinance>(
        await this.campaignFinanceService.getCampaignFinance(id)
      );

      if(this.campaign){
              // Inizializza gli array se non esistono per evitare errori
      this.campaign.dayOfTheWeek = this.campaign.dayOfTheWeek || [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
      ];
      this.campaign.includedAreas = this.campaign.includedAreas || []; // Province incluse
      this.campaign.excludedJobs = this.campaign.excludedJobs || []; // Professioni escluse

      console.log(this.campaign);
      this.loadProvinces(); // Carica l'elenco delle province
      this.loadJobs(); // Carica l'elenco delle province

      
      this.loading = false;

      // console.log("Campagna caricata:", this.campaign); // Log per verificare il contenuto
      // console.log("Aree incluse:", this.campaign.includedAreas); // Verifica che le aree siano caricate
      }

    }
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  
  updateDailyMax(value: number) {
    this.campaign.dailyMax = value;
  }

  loadProvinces() {
    this.http.get<any[]>("assets/data/province.json").subscribe(
      (data) => {
        this.provinces = data;
      },
      (error) => {
        console.error("Errore durante il caricamento delle province:", error);
      }
    );
  }

  loadJobs() {
    this.http.get<any[]>("assets/data/professioni.json").subscribe(
      (data) => {
        this.jobs = data;
      },
      (error) => {
        console.error(
          "Errore durante il caricamento delle professioni:",
          error
        );
      }
    );
  }

  onAreaInputChange(searchTerm: string, index: number) {
    this.activeInputIndex = index;
    if (searchTerm) {
      this.filteredProvinces = this.provinces.filter((province) =>
        province.nome.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      this.filteredProvinces = [];
    }
  }

  selectProvince(provinceName: string, index: number) {
    this.campaign.includedAreas[index] = provinceName;
    this.filteredProvinces = [];
    this.activeInputIndex = null;
  }

  onJobInputChange(searchTerm: string, index: number) {
    this.activeJobInputIndex = index;
    if (searchTerm) {
      this.filteredJobs = this.jobs.filter((job) =>
        job.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      this.filteredJobs = [];
    }
  }

  selectJob(job: any, index: number) {
    this.campaign.excludedJobs[index] = job.value;
    this.filteredJobs = [];
    this.activeJobInputIndex = null;
  }

  addArea() {
    if (this.campaign.includedAreas) {
      this.campaign.includedAreas.push(""); // Aggiunge un'area vuota
    } else {
      this.campaign.includedAreas = [""]; // Inizializza con un'area vuota
    }
  }

  removeArea(i) {
    this.campaign.includedAreas.splice(i, 1);
  }

  addPrivacy() {
    if (this.campaign.privacies) {

      this.campaign.privacies.push({
        paramName: "",
        text: "",
        required: false,
      }); // Aggiunge un'area vuota
    } else {
      this.campaign.privacies = [
        {
          paramName: "",
          text: "",
          required: false,
        },
      ]; // Inizializza con un'area vuota
    }
  }

  removePrivacy(i) {
    this.campaign.privacies.splice(i, 1);
  }

  addExcludedJob() {
    if (this.campaign.excludedJobs) {
      this.campaign.excludedJobs.push(""); // Aggiunge una professione vuota
    } else {
      this.campaign.excludedJobs = [""]; // Inizializza con una professione vuota
    }
  }

  removeJob(i) {
    this.campaign.excludedJobs.splice(i, 1);
  }

  trackByFn(index: number, province: any) {
    return province.sigla;
  }

  trackByJobFn(index: number, job: any) {
    return job.value;
  }

  async save() {
    if (this.id) {
      try {
        const result = await this.campaignFinanceService.editCampaignFinance(this.campaign, this.id);
        //this.router.navigate(["home", "finance-campaigns"]);
        if (result) {location.reload();}
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let data = <any>(
          await this.campaignFinanceService.createCampaignFinance(this.campaign)
        );
        this.id = data.id;
        this.router.navigate(["home", "finance-campaigns"]);
      } catch (e) {
        console.error(e);
      }
    }
  }


}
